import { useGetFormStructureQuery } from "api/TenantSlug/FormStructure/hooks.ts";
import { COMMON_GET_FORM_STRUCTURE_QUERY_FILTERS } from "api/TenantSlug/FormStructure/queryOptions.ts";
import { FormStructureDetailEditorForm } from "components/Forms/FormStructureDetailEditorForm/FormStructureDetailEditorForm.tsx";
import { QueryState } from "components/UI/QueryState/QueryState.tsx";
import { SectionContentWrapper } from "components/UI/SectionContentWrapper";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { FormId } from "types/models.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getToolStructureFeedHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/editor-old/"
)({
    component: FeedStructureEditorOldPage,
    staticData: {
        permissions: [PermissionEnum.ToolStructureFeedEditor],
        showInSideMenu: false,
        label: "pages.tool.structure.feed.editor-old.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.tool.structure.feed.editor-old.title"),
        };
    },
});

function FeedStructureEditorOldPage() {
    const { formStructureId } = Route.useParams();
    const { data, isLoading, isError } = useGetFormStructureQuery(
        formStructureId,
        COMMON_GET_FORM_STRUCTURE_QUERY_FILTERS
    );
    const formStructure = data?.formStructure;

    if (!formStructure) {
        return (
            <QueryState
                isLoading={isLoading}
                isError={isError || !isLoading}
                errorKey="errors.loading_form_structure"
            />
        );
    }

    return (
        <TenantPage
            headerNavigationItems={getToolStructureFeedHeaderItems}
            isEdit={true}
            saveFormId={FormId.FormStructureEditor}
        >
            <SectionContentWrapper withBackground>
                <FormStructureDetailEditorForm key={formStructureId} formStructure={formStructure} />
            </SectionContentWrapper>
        </TenantPage>
    );
}
